export type BrowserLanguage = string;

export const SET_BROWSER_LANGUAGE = 'SET_BROWSER_LANGUAGE';
